export default {
  path: 'drivers',
  name: 'People',
  component: () => import(/* webpackChunkName: "people" */ '../views/PeopleIndexView.vue')
}
